/**
 * The breakpoint at which Ask The Expert is toggled from desktop to mobile
 * See: app/assets/stylesheets/components/lessons/expert.scss
 */
export const ASK_THE_EXPERT_DESKTOP_MIN_WIDTH = 801;

/**
 * The success state in milliseconds
 */
export const ASK_THE_EXPORT_SUCCESS_STATE_DELAY = 2000;
